import { useStaticQuery, graphql } from 'gatsby'

const useHomeButtonImage = () => {
  const data = useStaticQuery(graphql`
    {
      file(relativePath: { regex: "/homeVideoThumb/" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)
  return data.file.childImageSharp.gatsbyImageData
}

export default useHomeButtonImage
